import React, { ReactNode } from 'react';

import Portal from '@material-ui/core/Portal';

/**
 * Wrap any component with this portal if you want to stick it to the top of the page.
 * This portal places your component in a div called 'stickyHeadersContainer'.
 * In case any strips like MaintenanceStrip is showing, 'stickyHeadersContainer'
 * adjusts it's own position so that it appears below them.
 * So you don't have to worry about positioning anymore.
 */
const StickyHeadersPortal = ({
  disablePortal,
  children,
}: {
  disablePortal?: boolean;
  children: ReactNode;
}) => {
  const container = document.getElementById('stickyHeadersContainer');
  return (
    <Portal container={container} disablePortal={disablePortal}>
      {children}
    </Portal>
  );
};

export default StickyHeadersPortal;
